/**
 * Bundle of base64-blob
 * Generated: 2019-07-23
 * Version: 1.4.1
 * License: MIT
 * Author: livelybone(2631541504@qq.com)
 */

import b64ToBlob from 'b64-to-blob';

/* global Promise */

/**
 * dataURL to blob
 * */
function base64ToBlob(base64) {
  try {
    var arr = base64.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    return Promise.resolve(b64ToBlob(arr[1], mime))
  } catch (e) {
    return Promise.reject(e)
  }
}

/**
 * blob to dataURL
 * */
function blobToBase64(blob) {
  return new Promise(function (res, rej) {
    try {
      var a = new FileReader();
      a.onload = function (e) {
        res(e.target.result);
      };
      a.readAsDataURL(blob);
    } catch (e) {
      rej(e);
    }
  })
}

export { base64ToBlob, blobToBase64 };
